import {Field, FieldError, Input, Label} from "ui/blocks/guestMessaging/GuestUI";
import {digitsOnly} from "./useQuickBookingAuth";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// (555) 123-4567 while typing. US numbers only, like the existing sign-up.
export const formatPhone = (v) => {
    let d = digitsOnly(v);
    if (d.length === 11 && d[0] === "1") d = d.slice(1);
    d = d.slice(0, 10);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const validateGuestDetails = ({name, email, phone}) => {
    const errors = {};
    if (!name.trim()) errors.name = "Enter your full name.";
    if (!EMAIL_RE.test(email.trim())) errors.email = "Enter a valid email address.";
    if (digitsOnly(phone).length !== 10) errors.phone = "Enter a 10-digit US phone number.";
    return errors;
};

/** Name, email and phone for a new student. `values`: {name, email, phone}. */
export const GuestDetailsFields = ({values, errors = {}, onChange, idPrefix = "qb", disabled}) => {
    const set = (field, format = (v) => v) => (e) => onChange(field, format(e.target.value));
    return (
        <>
            <Field>
                <Label htmlFor={`${idPrefix}-name`}>Full name</Label>
                <Input id={`${idPrefix}-name`} autoComplete="name" maxLength={80} value={values.name}
                       onChange={set("name")} aria-invalid={Boolean(errors.name)} disabled={disabled}/>
                {errors.name && <FieldError>{errors.name}</FieldError>}
            </Field>
            <Field>
                <Label htmlFor={`${idPrefix}-email`}>Email address</Label>
                <Input id={`${idPrefix}-email`} type="email" autoComplete="email" inputMode="email" maxLength={254}
                       value={values.email} onChange={set("email")} aria-invalid={Boolean(errors.email)} disabled={disabled}/>
                {errors.email && <FieldError>{errors.email}</FieldError>}
            </Field>
            <Field>
                <Label htmlFor={`${idPrefix}-phone`}>Phone number</Label>
                <Input id={`${idPrefix}-phone`} type="tel" autoComplete="tel-national" inputMode="tel" placeholder="(555) 123-4567"
                       value={values.phone} onChange={set("phone", formatPhone)} aria-invalid={Boolean(errors.phone)} disabled={disabled}/>
                {errors.phone && <FieldError>{errors.phone}</FieldError>}
            </Field>
        </>
    );
};
